import { PageState } from 'models/PageState';

export const getNewsletterUsps = (state: PageState) => state.newsletter.newsletterUSPs;
export const getNewsletterDisclaimer = (state: PageState) => state.newsletter.newsletterDisclaimer;

export const isMarketingCookieAccepted = (state: PageState): boolean =>
  state.newsletter ? state.newsletter.marketingCookieConsent : false;

export const isNewsletterPushActive = (state: PageState): boolean =>
  state.newsletter ? state.newsletter.showPopUp : false;

export const isNewsletterPushDiscountActive = (state: PageState): boolean =>
  state.newsletter ? state.newsletter.showDiscount : false;
